import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeartEmpty = (props) => /* @__PURE__ */ _jsx("svg", {
	"data-testid": "unheart-svg",
	viewBox: "4.7 4.5 22 22",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M15.7 25.01C15.35 25.01 14.99 24.92 14.67 24.74C12.4 23.46 5 18.81 5 12.56C5 9.04 7.6 6.18002 10.8 6.18002C12.78 6.18002 14.56 7.25001 15.62 9.01001C16.66 7.17001 18.51 6 20.54 6C23.74 6 26.34 8.86 26.34 12.38C26.34 18.73 18.99 23.44 16.74 24.73C16.41 24.92 16.05 25.01 15.7 25.01ZM10.81 7.39001C8.27 7.39001 6.21001 9.71001 6.21001 12.57C6.21001 18.17 13.14 22.5 15.27 23.7C15.55 23.86 15.88 23.85 16.16 23.7C18.27 22.49 25.16 18.09 25.16 12.39C25.16 9.54001 23.1 7.21002 20.56 7.21002C18.62 7.21002 16.89 8.58999 16.23 10.65C16.15 10.9 15.93 11.06 15.67 11.07C15.42 11.07 15.19 10.91 15.1 10.67C14.4 8.68001 12.72 7.39999 10.83 7.39999L10.81 7.39001Z"
	})
});
export { SvgHeartEmpty as ReactComponent };
